import _styled from "@emotion/styled/base";
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
import { css } from '@emotion/react';
import { colors, rem, spacing, getResetByTag } from '../../../styles';
import StyledIcon from '../../icon/icon.styles';
var dropDownIconContainerDefaultStyles = function dropDownIconContainerDefaultStyles(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/css("align-items:center;background-color:", colors.transparent, ";border-left-style:solid;border-left-width:", rem(1), ";display:flex;justify-content:center;min-width:", rem(spacing.spacingControlHeightLg), ";transition:box-shadow 0.2s;width:", rem(32), ";", StyledIcon, "{>path{fill:", colors.navy_500, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropDownIconContainerDefaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledDropdownIconContainer = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eba1m020"
} : {
  target: "eba1m020",
  label: "StyledDropdownIconContainer"
})(resetStyles, dropDownIconContainerDefaultStyles);
export default StyledDropdownIconContainer;